import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  operationBtn: {
    fontSize: 14,
    fontWeight: 700,
    color: 'rgba(67, 134, 229, 1)',
  },
}));
